"use client";

import Image from "next/image";
import "@/styles/page/lich-su/_intro.scss";

type LichSuIntroProps = {
  title?: string;
  introText?: string;
  imageSrc?: string;
  imageAlt?: string;
};

const DEFAULT_INTRO_TEXT =
  "Trường Đại học Ngân hàng TP. Hồ Chí Minh (Ho Chi Minh University of Banking - HUB) là trường đại học công lập trực thuộc Ngân hàng Nhà nước Việt Nam, được thành lập từ ngày 16/12/1976. HUB có truyền tâm gần 50 năm hình thành và phát triển với 16 ngành đại học, 09 chương trình thạc sĩ và 03 ngành tiến sĩ. Đội ngũ Giáo sư – Phó Giáo sư – Tiến sĩ đạt hơn 54% tổng số giảng viên. 100% chương trình đào tạo của HUB đã được kiểm định chất lượng giáo dục theo chuẩn trong nước và quốc tế (MOET, AUN-QA).";

export default function LichSuIntro({
  title,
  introText = DEFAULT_INTRO_TEXT,
  imageSrc = "/assets/images/lichsu_img1.png",
  imageAlt = "Cơ sở Trường Đại học Ngân hàng TP. Hồ Chí Minh",
}: LichSuIntroProps) {
  const resolvedImageSrc =
    typeof imageSrc === "string" && imageSrc.trim().length > 0
      ? imageSrc
      : "/assets/images/lichsu_img1.png";
  const resolvedImageAlt =
    typeof imageAlt === "string" && imageAlt.trim().length > 0
      ? imageAlt
      : "Cơ sở Trường Đại học Ngân hàng TP. Hồ Chí Minh";

  return (
    <section className="history-intro">
      <div className="container">
        {title && <h2 className="history-intro__title">{title}</h2>}
        <p className="history-intro__text">{introText}</p>
      </div>
      <div className="history-large-image">
        <div className="container">
          <Image
            src={resolvedImageSrc}
            alt={resolvedImageAlt}
            className="history-large-image__img"
            width={1200}
            height={600}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}

